export function filtraParametriche(bets) {
	const parametricheMap = new Set();
    return bets.filter(bet => {
        if (bet.parametrica) {

            // Questo controllo è stato rimosso in quanto
            // filtra le scommesse parametriche dall'header nel caso in cui la mainLine non è quotata
            // o non è presente nel primo match
			// if (bet?.mainLine) {
			// 	if (bet.mainLine === bet.handicap) {
            //         return true;
            //     } else {
            //         return false;
            //     }
			// }

            if (!parametricheMap.has(bet.id)) {
                parametricheMap.add(bet.id);
                return true;
            } else {
                return false;
            }
        }
        return true;
    });
}
